import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { jarvsiRMSOnboardingActions } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingAction";
import { commonActions } from "stores/common/commonActions";
import { getKycCrossProductProps } from "helper/kycDocumentUpload";
import { config } from "config";

const mapStateToProps = (state) => {
    return {
        currentStage: state.jarvisRMS.rmsOnboarding.currentStage,
        tempCustomerPortfolioId: state.jarvisRMS.rmsOnboarding.portfolioId,
        isRMSOnboardingCompleted: state.jarvisRMS.rmsOnboarding.isOnboardingCompleted,
        panNumber: state.jarvisRMS.rmsOnboarding.panNumber,
        aadharNumber: state.jarvisRMS.rmsOnboarding.aadharNumber,
        dateOfBirth: state.jarvisRMS.rmsOnboarding.dateOfBirth,
        isPanUploaded: state.jarvisRMS.rmsOnboarding.isPanUploaded,
        isAadhaarFrontUploaded:
            state.jarvisRMS.rmsOnboarding.isAadhaarFrontUploaded,
        isAadhaarBackUploaded:
            state.jarvisRMS.rmsOnboarding.isAadhaarBackUploaded,
        panVerification: state.jarvisRMS.rmsOnboarding.panVerification,
        aadharFrontVerification:
            state.jarvisRMS.rmsOnboarding.aadharFrontVerification,
        aadharBackVerification:
            state.jarvisRMS.rmsOnboarding.aadharBackVerification,
        isManualKYC: state.jarvisRMS.rmsOnboarding.isManualKYC,
        loginProfile: state.customer.loginProfile,
        ...getKycCrossProductProps(state, config.productCodes.RMS),
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getRMSOnboardingDataAction:
                jarvsiRMSOnboardingActions.getOnboardingData,
            updateRMSOnboardingData:
                jarvsiRMSOnboardingActions.updateRMSOnboardingData,
            setToast: commonActions.setToast,
        },
        dispatch
    );

const RMSCkycStore = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);
export default RMSCkycStore;
